import { render, staticRenderFns } from "./Regionais.vue?vue&type=template&id=4c4935e2&scoped=true&lang=pug"
import script from "./Regionais.vue?vue&type=script&lang=js"
export * from "./Regionais.vue?vue&type=script&lang=js"
import style0 from "./Regionais.vue?vue&type=style&index=0&id=4c4935e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4935e2",
  null
  
)

export default component.exports